export default "__VITE_ASSET__DY8SZbD5__"